import { render, staticRenderFns } from "./TicketsStep.vue?vue&type=template&id=f8b7f26a&scoped=true&"
import script from "./TicketsStep.vue?vue&type=script&lang=js&"
export * from "./TicketsStep.vue?vue&type=script&lang=js&"
import style0 from "./TicketsStep.vue?vue&type=style&index=0&id=f8b7f26a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b7f26a",
  null
  
)

export default component.exports